// @flow
import React, { Component } from "react";
import _ from "lodash";
import styles from "./Notifications.scss";
import { connect } from "react-redux";
import I18n from "../../i18n/I18n";
import Actions from "../../actions/Creators";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import NotificationComponent from "../../components/notifications/notifications/Notifications";
import { Layout, Loader } from "../../components/common/";

class Notifications extends Component<void, State> {
  state = {
    readFilter: "all",
    change: false
  };

  componentDidMount = () => {
    this.getNotification();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.change) {
      this.getNotification();
    }
  };

  getNotification = () => {
    const { readFilter } = this.state;
    let query = "";
    query =
      readFilter && readFilter !== "all" ? `is_read=${readFilter}` : query;
    this.props.dispatch(Actions.getNotification(query, true));
    this.setState({
      change: false
    });
  };

  readNotification = notObj => {
    this.props.dispatch(Actions.readNotification(notObj));
  };

  notificationClick = (id_notification, link) => {
    const obj = {
      id_notification,
      is_read: true
    };
    this.readNotification(obj);
    window.open(link);
  };

  onReadChange = e => {
    const newState = {};
    newState.readFilter = e;
    newState.change = true;
    this.setState(newState);
  };

  render() {
    const { notification, isLoading } = this.props;
    const name = this.props.user ? this.props.user.firstName : "";
    const data =
      notification && notification.notifications
        ? notification.notifications
        : "";

    const readOptions = [
      {
        value: "all",
        key: "all",
        label: I18n.getText("notification.all")
      },
      {
        value: "1",
        key: "1",
        label: I18n.getText("notification.read")
      },
      {
        value: "0",
        key: "0",
        label: I18n.getText("notification.unread")
      }
    ];

    return (
      <Layout title={"notification.title"}>
        <div className={styles.notificationCtr}>
          <div className={styles.topWrapper}>
            <div className={styles.heading}>
              {I18n.getText("notification.notification-center")}
            </div>
            {false && (
              <div>
                {I18n.getText("notification.notification-summary", {
                  name: name
                })}
              </div>
            )}
          </div>
          <div className={styles.dropdownWrapper}>
            <div className={styles.eachFilter}>
              <Dropdown
                onChange={this.onReadChange}
                selected={this.state.readFilter}
                options={readOptions}
                label={I18n.getText("imports.status", {}, "Status")}
              />
            </div>
          </div>
          <div className={styles.ctr}>
            {!isLoading ? (
              <NotificationComponent
                data={data}
                type={this.state.readFilter}
                readNotification={this.notificationClick}
              />
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    browser: state.browser,
    notification: state.session.listNotification,
    isLoading: state.session.isNotificationLoading
  };
};

export default connect(mapStateToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/containers/notifications/Notifications.js